import React from 'react';
import { useCallback, useState } from 'react';
import './App.css';

import LoginForm from './components/login';
import navValues from './helpers/navValues';
import TableauDashboardList from './components/dashboardlist';
import ComponentPicker from './components/componentPicker';
import AuthContext from './context/authContext';
import 'bootstrap/dist/css/bootstrap.min.css';

const navigationContext = React.createContext(navValues.login);

function App() {

  const navigate = useCallback(
    (navTo, param) => setNav({current: navTo, param, navigate}),
    []
  );
  const [authstatus, setauthstatus] = useState(false);
  const login = () => {
    setauthstatus(true);
  };
  const logout = () => {
    setauthstatus(false);
  };

  const [nav, setNav] = useState({current: navValues.home, navigate});
  return (
    <AuthContext.Provider value={{ status: authstatus, login: login, logout: logout }}>
      {authstatus ? <>     
      <navigationContext.Provider value={{nav}}>
            <TableauDashboardList />
            <ComponentPicker currentNavLocation={nav.current} />
      </navigationContext.Provider>
      </> : <LoginForm />};
    </AuthContext.Provider>
  );
}

export {navigationContext};
export default App;
